import { updatesData } from '@/mocks/home';

const typeColorMap: Record<string, string> = {
  '重要': 'bg-secondary-100 text-secondary-700',
  '快讯': 'bg-primary-100 text-primary-700',
  '热议': 'bg-accent-100 text-accent-700',
  '爆料': 'bg-background-200 text-foreground-700',
  '官宣': 'bg-primary-100 text-primary-700',
  '回顾': 'bg-background-200 text-foreground-700',
  '话题': 'bg-accent-100 text-accent-700',
  '数据': 'bg-background-200 text-foreground-700',
  '预告': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">最新动态</h2>
          <p className="text-foreground-600 text-sm md:text-base">实时追踪，分秒不落</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200 space-y-6">
            {updatesData.map((update) => (
              <div key={update.id} className="relative">
                <div className="absolute -left-[33px] md:-left-[37px] top-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-50 border-2 border-background-200">
                  <span className={`w-3 h-3 rounded-full ${
                    update.type === '重要' ? 'bg-secondary-500' :
                    update.type === '快讯' ? 'bg-primary-500' :
                    update.type === '热议' ? 'bg-accent-500' : 'bg-background-400'
                  }`}></span>
                </div>
                <div className="pb-6 border-b border-background-200/50">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className={`px-2 py-0.5 rounded text-xs font-semibold ${typeColorMap[update.type] || 'bg-background-200 text-foreground-600'}`}>
                      {update.type}
                    </span>
                    <span className="text-xs text-foreground-500">{update.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{update.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}